<template>

<footer id="main-footer">
  <div id="footer-container">
    <div id="footer1">
      <p>
        © 成都纳瑟可科技有限公司 All Rights Reserved |
        <a href="">Terms of Use</a> |
        <a href="">Privacy Policy</a>
      </p>
    </div>

    <div id="footer2">
      <img :src="img_ba" class="beian"/>
      <a href="https://beian.miit.gov.cn" rel="noreferrer" target="_blank">蜀ICP备2025137118号 ｜ 川公网安备51019002007956号</a >
    </div>
  </div>
</footer>

</template>

<script>
import img_ba from '@/assets/images/beian.jpg';

export default {
  name: 'FooterView',
  data: () => ({
    img_ba
  })
}
</script>
